import EventBus from '../../eventbus.js';

// eslint-disable-next-line
function parseElse(context, data) {
  // 最后那个else的逻辑
  // console.log(data);
}

const store = [];
const parser = Object.create({
  push(key, fn) {
    store.push({
      key,
      fn,
    });
  },
  run(context, data) {
    const type = data.type;
    for (let i = 0; i < store.length; i += 1) {
      if (store[i].key === type) {
        return store[i].fn.call(this, data, context);
      }
    }
    parseElse(context, data);
    return null;
  },
});

/**
 * ack，返回了该条消息的id，用于删除聊天的需求
 */
parser.push('ack', (data) => {
  $('.mod-chatpanel-consumer').last().attr('data-mid', data.id);
  // console.log(data);
});

parser.push('robot', (data) => {
  const param = JSON.parse(data.body);

  return {
    type: 'robot',
    body: {
      extraParams: param.extraParams,
      lazy: data.lazy,
      text: param.text,
    },
  };
});


parser.push('knowledge', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'knowledge',
    body: param,
  };
});

parser.push('recommend', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'recommend',
    body: param,
  };
});


// /**
//  * 快捷短语
//  */
// parser.push('dynamic_shortcuts', (data) => {
//   const param = JSON.parse(data.body);
//   return {
//     type: 'shortcuts',
//     body: param,
//   };
// });

/**
 * 转人工
 */
parser.push('session_availability', (data) => {
  EventBus.emit('liveAgent', data);
  return {
    type: 'empty',
  };
});


parser.push('noanswer', (data, context) => {
  // const param = JSON.parse(data.body);
  // // 有返回技能组，展示转人工入口
  // if (param.skillGroup) {
  //   context.app.shortcuts.push({
  //     isAdd: true,
  //     shortcuts: [{
  //       code: 'dispatch',
  //       means: {
  //         type: 'dispatch',
  //         content: JSON.stringify({
  //           skillGroupId: param.skillGroup,
  //           question: data.question,
  //         }),
  //       },
  //       name: context.app.util.lang.get('SHORTCUT:DISPATCH'),
  //     }],
  //   });
  //   return {
  //     type: 'robot',
  //     body: {
  //       text: context.app.util.lang.get('ROBOT:EXCEPTION'),
  //     },
  //   };
  // }
  const autoResponses = context.app.essentials.config.config.auto_responses;
  const autoRep = autoResponses && autoResponses.length > 0 ? autoResponses : [context.app.util.lang.get('ROBOT:NOANSWER')];
  // 没有技能组，返回兜底文案
  return {
    type: 'robot',
    body: {
      text: autoRep[0],
    },
  };
});


parser.push('error', (data, context) => ({
  type: 'robot',
  body: {
    text: context.app.util.lang.get('ROBOT:EXCEPTION'),
  },
}));

parser.push('options', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'options',
    body: param,
  };
});

// lazada order
parser.push('orderList', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'orderlist',
    body: {
      body: param,
      isRobot: true,
    },
  };
});

parser.push('orderDetail', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'orderdetail',
    body: {
      list: param,
      isRobot: true,
    },
  };
});

parser.push('cancelItem', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'cancel',
    body: {
      list: param,
      isRobot: true,
    },
  };
});

parser.push('text_button', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'option',
    body: {
      list: param,
      isRobot: true,
    },
  };
});

parser.push('cancel_event', (data) => {
  const param = JSON.parse(data.body);
  EventBus.emit('cancelResult', param);
  return {
    type: 'empty',
  };
});

parser.push('login_event', (data) => {
  const param = JSON.parse(data.body);
  EventBus.emit('login', param);
  return {
    type: 'empty',
  };
});

parser.push('feedback', (data) => {
  const param = JSON.parse(data.body);
  const p = Object.assign({}, param, { chatUuid: data.header.chatUuid || '' });
  return {
    type: 'feedback',
    body: p,
  };
});

parser.push('shortcut', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'dynamic_shortcuts',
    body: {
      isAdd: false,
      shortcuts: param,
    },
  };
});

parser.push('live_agent_event', (data) => {
  EventBus.emit('liveAgent', { entry: 'bfw', type: 'click', chatUuid: data.header.chatUuid, intent: '' });
  return {
    type: 'empty',
  };
});

parser.push('bank_transfer_event', (data) => {
  const param = JSON.parse(data.body);
  EventBus.emit('bankTransfer', param);
  return {
    type: 'empty',
  };
});

// session expired

parser.push('session_expired', (data) => {
  const param = JSON.parse(data.body);
  EventBus.emit('sessionExpired', param);
  return {
    type: 'empty',
  };
});

parser.push('text_link', (data) => {
  const param = JSON.parse(data.body);
  return {
    type: 'textlink',
    body: {
      text: param.text,
      link: param.link,
    },
  };
});

export default parser;



// WEBPACK FOOTER //
// ./src/app/context/channel/robot/parser.js